// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IPostCollabDocItem,
}                               from '../interfaces';

const publishPostCollaborativePreviewCutoff = async ({
    test,
    docId,
    previewCutoffParagraphId,
    previewCutoffCheckpointId,
}: {
    test: boolean,
    docId: string,
    previewCutoffParagraphId: string,
    previewCutoffCheckpointId?: string,
}): Promise<IPostCollabDocItem> => {
    const functions = getFunctions();
    const callable = httpsCallable<
        Record<string, boolean | string>,
        IPostCollabDocItem
    >(
        functions,
        'publishPostCollaborativePreviewCutoff',
    );
    const result = await callable({
        test,
        docId,
        previewCutoffParagraphId,
        ...(previewCutoffCheckpointId
            ? { previewCutoffCheckpointId }
            : {}),
    });
    return result.data as IPostCollabDocItem;
};

export default publishPostCollaborativePreviewCutoff;
